export default __webpack_public_path__ + "static/media/push48.799d0600.gif";